let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("7A5zJ"), load("ffEVr"), load("Wowvf"), load("hhss7"), load("aoUod")]).then(() => parcelRequire('fzGQR'));